<template>
    <v-card class="filter-con">
        <!-- <input type="text" class="input-field" placeholder="Search any location">  -->
        <div>
            <div class="border_box">
                <div class="flex space-between mb-1" style="flex-wrap: wrap">
                    <div class="grid_height flex mt-2" v-for="i in 5" :key="i">
                        <div class="grid_tile flex">
                            <v-radio-group v-model="radioGroup" row>
                                <div class="flex">
                                    <v-radio style="width: 14px" :value="1">
                                    </v-radio>
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <p
                                                style="
                                                    transform: translateY(6px);
                                                "
                                                class="text_radio"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                edcdeknc deknc ekc ejkc edcec
                                            </p>
                                        </template>
                                        <span>{{
                                            "edcdeknc deknc ekc ejkc edcec"
                                        }}</span>
                                    </v-tooltip>
                                </div>
                            </v-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex filter-buttons">
            <button class="remove">Clear</button>
            <button class="apply">Done</button>
        </div>
    </v-card>
</template>


<script>
import crop from "./cropfilter";
export default {
    name: "filters",

    components: {
        crop: crop,
    },

    data() {
        return {
            tabs: null,
            items: [{ tab: "Crop", content: "crop" }],
            locations: [
                { loc: "Kolkata" },
                { loc: "Kerala" },
                { loc: "Haryana" },
                { loc: "Delhi" },
                { loc: "Noida" },
                { loc: "Odhisa" },
                { loc: "Jharkhand" },
                { loc: "Bengaluru" },
                { loc: "Raipur" },
            ],
            disease: [
                { loc: "Rice" },
                { loc: "Hello" },
                { loc: "Flower" },
                { loc: "Rice" },
                { loc: "Noida" },
                { loc: "Fever" },
                { loc: "Nothing" },
            ],
            crop: [
                { loc: "Rice" },
                { loc: "Mawa" },
                { loc: "Flower" },
                { loc: "Rice" },
                { loc: "Noida" },
                { loc: "Spring" },
                { loc: "Roti" },
                { loc: "Grass" },
            ],
        };
    },
};
</script>


<style lang="scss" scoped>
.filter-con {
    //box-shadow: 3px 3px 7px rgba(23, 37, 20, 0.19);
    border-radius: 12px;
    padding: 30px;
    width: 420px;
    padding: auto;
}
.grid_height {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0px;
    background-color: white;
    width: 48.7%;
    justify-content: left;
    height: 27px;
    border-radius: 2px;
}

.v-tab {
    text-transform: capitalize;
    font-size: 0.95rem;
    font-weight: 450;
    padding: 0px 0px;
    margin-right: 25px;
    min-width: 45px;
}
.v-tab--active {
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 12px;
    text-decoration-thickness: 2px;
    text-decoration-color: #1d8d56;
}
.input-field {
    border: 1px solid #bfbfbf;
    width: 100%;
    border-radius: 5px;
    padding: 12px;
    margin: 20px auto 10px;
}
.filter-buttons {
    width: 100%;
    column-gap: 20px;

    button {
        padding: 15px 20px;
        border-radius: 5px;
        font-size: 0.8rem;
        font-weight: 500;
    }
}
.remove {
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.apply {
    background-color: #36983b;
    width: 50%;
    color: #fff;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
.border_box {
    border: 0.5px solid #bfbfbf !important;
    height: 240px;
    border-radius: 8px;
    margin-bottom: 1rem;
    overflow: hidden;
    overflow-y: scroll;
    padding-left: 18px;
}
.text_radio {
    width: 100px;
    white-space: nowrap;
    justify-content: flex-start;
    text-overflow: ellipsis;
    overflow: hidden;
}
.v-tooltip__content{
  background-color: #308434;
  color: #fbfbfb;
  /* background: #D8D8D8; */
  border: 0.6px solid #308434;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
  font-weight: 500;
}
</style>